<div class="ficha-oportunidades-venture h-100">
  <!-- #region 1 oportunidad -->
  @if (totalOportunidades === 1) {
  <div id="fichas-oportunidades-1" class="border-radius-2 border-ficha-oportunidad shadow-4">
    <div class="row p-2 p-lg-3 align-content-between">
      <div class="col-12 col-lg-5 col-xxl-4">
        <div class="d-flex h-100">
          @if (platformId === 'VENTURE') {
          <a id="ficha-proyecto-{{oportunidad.slug}}" routerLink="/{{oportunidad.slug}}"
            title="Ver proyecto: {{oportunidad.nombre}}" class="contenedor-img w-100"
            style="background-image: url('{{oportunidad.portadaMinifichaUrl}}');">
            @if (oportunidad.tipoEstadoProyectoCodigo === 'publicado' && oportunidad.porcientoFinanciado >= 100) {
            <div class="tag-activo-invertir-position">
              <app-tag-overfunding [plataforma]="'VENTURE'"></app-tag-overfunding>
            </div>
            }
          </a>
          }
          @if (platformId !== 'VENTURE') {
          <a id="ficha-proyecto-{{oportunidad.slug}}" href="{{domainUrl + '/' + oportunidad.slug}}"
            target="{{platformId === 'REALESTATE' || platformId == 'CREATIVE' ? '_self' : '_blank'}}"
            title="Ver proyecto: {{oportunidad.nombre}}" class="contenedor-img w-100"
            style="background-image: url('{{oportunidad.portadaMinifichaUrl}}');">
            @if (oportunidad.tipoEstadoProyectoCodigo === 'publicado' && oportunidad.porcientoFinanciado >= 100) {
            <div class="tag-activo-invertir-position">
              <app-tag-overfunding [plataforma]="'VENTURE'"></app-tag-overfunding>
            </div>
            }
          </a>
          }
        </div>
      </div>
      <div class="col-12 col-lg-7 col-xxl-8">
        <div class="row h-100">
          <div class="col-12 mb-2">
            <div class="row align-items-center mt-2 mt-lg-0">
              @if (oportunidad.tipoEstadoProyectoCodigo === 'publicado') {
              <div class="col-12 col-sm-6 mt-2 mt-lg-0">
                <app-dias-restantes [plataforma]="'venture'" [diasRestantes]="oportunidad.diasRestantes"
                  [isPlazoAmpliado]="oportunidad.isPlazoAmpliado"></app-dias-restantes>
              </div>
              }
              <div class="col-12 col-sm-6 mt-2 mt-lg-0 text-end"
                [ngClass]="{'col-sm-6' : oportunidad.tipoEstadoProyectoCodigo === 'publicado'}">
                <app-tag-estado-proyecto
                  [tipoEstadoProyecto]="{ nombre: oportunidad.tipoEstadoProyecto, codigo: oportunidad.tipoEstadoProyectoCodigo}"></app-tag-estado-proyecto>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <h2 class="h2-sembiold primary-900 mb-2" matTooltip={{oportunidad.nombre}} matTooltipPosition="below">
                  {{oportunidad.nombre | maxCharacters:30}}</h2>
                <p class="p2-medium neutral-900 mb-2">
                  {{oportunidad.descripcionMini | maxCharacters:250}}</p>
              </div>
            </div>
          </div>
          <div class="col-12 align-self-end">
            @if (oportunidad.tipoEstadoProyectoCodigo === 'publicado') {
            <div class="row align-items-end">
              <div class="col-12 col-lg-7">
                <div class="col d-flex justify-content-between align-items-end">
                  <p class="d-none d-lg-block p2-medium primary-900 mb-1">Objetivo:</p>
                  <p class="p2-cifras primary-900 mb-1">
                    {{oportunidad.capitalSolicitado | euroCurrency:'EUR':'symbol':'1.0-0'}}
                  </p>
                </div>
                <app-progress-bar [porcientoCompletado]="oportunidad.porcientoFinanciado"></app-progress-bar>
              </div>
              <div class="d-none d-lg-block col-5 ps-4 text-end">
                @if (platformId === 'VENTURE') {
                <app-btn-link [linkId]="'btn-ver-proyecto-{{oportunidad.slug}}'" [linkClass]="'w-100'"
                  [linkUrl]="'/' + oportunidad.slug" [linkTitle]="'Ver proyecto'"></app-btn-link>
                }
                @if (platformId !== 'VENTURE') {
                <app-btn-link [linkId]="'btn-ver-proyecto-{{oportunidad.slug}}'" [linkType]="'href'"
                  [linkTarget]="(platformId === 'REALESTATE' || platformId == 'CREATIVE') ? '_self' : '_blank'"
                  [linkClass]="'w-100'" [linkUrl]="domainUrl + '/' + oportunidad.slug"
                  [linkTitle]="'Ver proyecto'"></app-btn-link>
                }
              </div>
              <div class="col-12 mt-2 col-lg-7">
                <span class="p2-regular neutral-900">
                  {{oportunidad.capitalRecaudado | euroCurrency:'EUR':'symbol':'1.0-0'}}
                  conseguidos | {{oportunidad.porcientoFinanciado}}%
                </span>
              </div>
              <div class="col-12 col-lg-5 ps-lg-4">
                <div class="d-block d-lg-none mt-3 mb-2 pb-1">
                  @if (platformId === 'VENTURE') {
                  <app-btn-link [linkId]="'btn-ver-proyecto-{{oportunidad.slug}}'" [linkClass]="'w-100'"
                    [linkUrl]="'/' + oportunidad.slug" [linkTitle]="'Ver proyecto'"></app-btn-link>
                  }
                  @if (platformId !== 'VENTURE') {
                  <app-btn-link [linkId]="'btn-ver-proyecto-{{oportunidad.slug}}'" [linkType]="'href'"
                    [linkTarget]="(platformId === 'REALESTATE' || platformId == 'CREATIVE') ? '_self' : '_blank'"
                    [linkClass]="'w-100'" [linkUrl]="domainUrl + '/' + oportunidad.slug"
                    [linkTitle]="'Ver proyecto'"></app-btn-link>
                  }
                </div>
                <p class="neutral-900 p3-regular">
                  <span class="p3-semibold">{{oportunidad.inversoresInteresados}}</span>
                  <span> inversores interesados</span>
                </p>
              </div>
            </div>
            }
            @if (oportunidad.tipoEstadoProyectoCodigo === 'privado') {
            <div class="row align-items-end mb-2">
              <div class="col-12 col-xl-8">
                <div class="row align-items-center">
                  <div class="col-12 mb-4 mb-xl-1">
                    <p class="p2-cifras primary-900">
                      {{oportunidad.capitalSolicitado |
                      euroCurrency:'EUR':'symbol':'1.0-0'}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-xl-7">
                <a href="mailto:venture@segofinance.com" title="Contactar para obtener más información"
                  class="link2-bold primary-900">
                  <div class="d-flex align-items-center mb-4 mb-xl-0">
                    <span class="material-symbols-outlined secondary-venture-500 me-1 me-lg-2">mark_email_read</span>
                    Más información
                  </div>
                </a>
              </div>
              <div class="col-12 col-xl-5 ps-xl-4 text-end">
                @if (platformId === 'VENTURE') {
                <app-btn-link [linkId]="'btn-ver-proyecto-{{oportunidad.slug}}'" [linkClass]="'w-100'"
                  [linkUrl]="'/' + oportunidad.slug" [linkTitle]="'Ver proyecto'"></app-btn-link>
                }
                @if (platformId !== 'VENTURE') {
                <app-btn-link [linkId]="'btn-ver-proyecto-{{oportunidad.slug}}'" [linkType]="'href'"
                  [linkTarget]="(platformId === 'REALESTATE' || platformId == 'CREATIVE') ? '_self' : '_blank'"
                  [linkClass]="'w-100'" [linkUrl]="domainUrl + '/' + oportunidad.slug"
                  [linkTitle]="'Ver proyecto'"></app-btn-link>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  } 
  <!-- #endregion-->

  <!-- #region 2 o más oportunidades -->
  @else {
  <div id="fichas-oportunidades-2" class="border-radius-2 shadow-4 border-ficha-oportunidad h-100">
    <a id="ficha-proyecto-{{oportunidad.slug}}" routerLink="/{{oportunidad.slug}}"
      title="Ver proyecto: {{oportunidad.nombre}}">
      <div class="contenedor-img" style="background-image: url({{oportunidad.portadaMinifichaUrl}});">
        @if (oportunidad.tipoEstadoProyectoCodigo === 'publicado' && oportunidad.porcientoFinanciado >= 100) {
        <div class="tag-activo-invertir-position">
          <app-tag-overfunding [plataforma]="'VENTURE'"></app-tag-overfunding>
        </div>
        }
      </div>
    </a>
    <div class="p-3">
      <div class="row card-container">
        <div class="col-12">
          <div class="row">
            @if (oportunidad.tipoEstadoProyectoCodigo === 'publicado') {
            <div class="col-12 col-sm-6">
              <app-dias-restantes [plataforma]="'venture'" [diasRestantes]="oportunidad.diasRestantes"
                [isPlazoAmpliado]="oportunidad.isPlazoAmpliado"></app-dias-restantes>
            </div>
            }
            <div class="col-12 col-sm-6 mt-2 mt-lg-0 text-end"
              [ngClass]="{'col-sm-6' : oportunidad.tipoEstadoProyectoCodigo === 'publicado'}">
              <app-tag-estado-proyecto
                [tipoEstadoProyecto]="{ nombre: oportunidad.tipoEstadoProyecto, codigo: oportunidad.tipoEstadoProyectoCodigo}"></app-tag-estado-proyecto>
            </div>
          </div>
          <div class="row mt-2 mb-3">
            <div class="col-12">
              <h3 class="primary-900 mb-2" matTooltip={{oportunidad.nombre}} matTooltipPosition="below">
                {{oportunidad.nombre | maxCharacters:30}}</h3>
              <p class="p3-medium neutral-900">
                {{oportunidad.descripcionMini | maxCharacters: 250}}</p>
            </div>
          </div>
        </div>
        <div class="col-12 align-self-end">
          @if (oportunidad.tipoEstadoProyectoCodigo === 'publicado') {
          <div class="row align-items-end">
            <div class="col-12 col-xl-7">
              <div class="col d-flex align-items-end justify-content-between">
                <p class="d-none d-xl-block primary-900 p2-medium mb-1">
                  Objetivo:</p>
                <p class="primary-900 p2-cifras">
                  {{oportunidad.capitalSolicitado |
                  euroCurrency:'EUR':'symbol':'1.0-0'}}</p>
              </div>
              <app-progress-bar [porcientoCompletado]="oportunidad.porcientoFinanciado"></app-progress-bar>
            </div>
            <div class="d-none d-xl-block col-5 text-end">
              <app-btn-link [linkId]="'btn-ver-proyecto-{{oportunidad.slug}}'" [linkClass]="'w-100 px-3'"
                [linkUrl]="'/' + oportunidad.slug" [linkTitle]="'Ver proyecto'"></app-btn-link>
            </div>
            <div class="col-12 mt-2 col-xl-7">
              <span class="p2-regular neutral-900">
                {{oportunidad.capitalRecaudado | euroCurrency:'EUR':'symbol':'1.0-0'}}
                conseguidos | {{oportunidad.porcientoFinanciado}}%
              </span>
            </div>
            <div class="col-12 col-xl-5">
              <div class="d-block d-xl-none mt-3 mb-2 pb-1">
                <app-btn-link [linkId]="'btn-ver-proyecto-{{oportunidad.slug}}'" [linkClass]="'w-100'"
                  [linkUrl]="'/' + oportunidad.slug" [linkTitle]="'Ver proyecto'"></app-btn-link>
              </div>
              <p class="neutral-900 p3-regular">
                <span class="p3-semibold">{{oportunidad.inversoresInteresados}}</span>
                <span> inversores interesados</span>
              </p>
            </div>
          </div>
          }
          @if (oportunidad.tipoEstadoProyectoCodigo === 'privado') {
          <div class="row align-items-end">
            <div class="col-12 col-xl-8">
              <div class="row align-items-center">
                <div class="col-12 mb-1">
                  <p class="primary-900 p2-cifras">
                    {{oportunidad.capitalSolicitado |
                    euroCurrency:'EUR':'symbol':'1.0-0'}}</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-xl-7">
              <a href="mailto:venture@segofinance.com" title="Contactar para obtener más información"
                class="link2-bold primary-900">
                <div class="d-flex align-items-center mb-4 mb-xl-0">
                  <span class="secondary-venture-500 material-symbols-outlined me-1 me-lg-2">mark_email_read</span>
                  Más información
                </div>
              </a>
            </div>
            <div class="col-12 col-xl-5 text-end">
              <app-btn-link [linkId]="'btn-ver-proyecto-{{oportunidad.slug}}'" [linkClass]="'w-100 px-3'"
                [linkUrl]="'/' + oportunidad.slug" [linkTitle]="'Ver proyecto'"></app-btn-link>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  }
  <!--#endregion-->
</div>